import getSubmoduleInfoByName from './getSubmoduleInfoByName';
import formatString from './formatString';

const isNumeric = (val) => typeof val === 'number' && !isNaN(val);

const parsePayloadData = (screens = [], data = {}, parent = null) => {
  let payloadData = [];
  
  Object.keys(data).filter(key => !key.toLowerCase().includes('helper')).forEach((key, idx) => {
    let payloadObj = {};
    
    if (Array.isArray(data[key])){ // es un array?
      data[key].forEach((element, i) => {
        if (typeof element === 'object') {
          const items = parsePayloadData(screens, element.item, key);
          const photos = [];

          if (element.photos !== null) {
            element.photos.forEach((photo, ind) => {
              photos.push(parsePayloadData(screens, {image: photo}, key)[0]);
            })
          }

          // Solo agregar si tiene items o photos con contenido
          if (items.length > 0 || photos.length > 0) {
            payloadObj[`${key}-${i}`] = {
              items: items,
              photos: photos
            }
          }
        }
				else {
					const submodule = getSubmoduleInfoByName(
						screens,  // screens
						key,      // key
						element,  // photo_types object
						false,    // has photo_types
						parent    // parent
					);
					const data = isNumeric(submodule) ? submodule : formatString(submodule);
					payloadObj[key] = payloadObj[key] ? `${payloadObj[key]}\n${data}` : data;
				}
      });

      // Solo agregar si payloadObj tiene contenido
      if (Object.keys(payloadObj).length > 0) {
        payloadData.push(payloadObj)
      }
    }
    else if (typeof data[key] === 'object'){ // es un objeto?
      if (data[key] !== null) {
        // Solo procesar si tiene image o photo_types con valores
        const hasImage = data[key]['image'] !== null && data[key]['image'] !== undefined;
        const hasPhotoTypes = data[key]['photo_types'] !== null && data[key]['photo_types'] !== undefined;

        if (hasImage || hasPhotoTypes) {
          if (hasPhotoTypes){
            let submodule = getSubmoduleInfoByName(
              screens,                                    // screens
              key,                                        // key
              Object.values(data[key]['photo_types'])[0], // photo_types object
              true,                                       // has photo_types
              parent                                      // parent
            );

            payloadObj['photo_type'] = submodule;
          }
          if (hasImage) {
            payloadObj[key] = data[key]['image']['$oid'];
          }

          payloadData.push(payloadObj);
        }
      }
    }
    else{ // es una key
      let submodule = getSubmoduleInfoByName(
        screens,    // screens
        key,        // key
        data[key],  // photo_types object
        false,      // has photo_types
        parent      // parent
      );

      // Asegurar que siempre tenga un valor
      const resolved = submodule !== null && submodule !== undefined ? submodule : data[key];
      payloadObj[key] = isNumeric(resolved) ? resolved : formatString(resolved);
      payloadData.push(payloadObj);
    }
  });

  return payloadData
}

export default parsePayloadData;
